export default function buildOptions(immutableList) {
  return immutableList && immutableList.toJS && immutableList.toJS().map(ss => ({
    label : ss.title,
    value : ss.id,
  }));
}
